import styled from "styled-components";

export const BlurredContainer = styled.div`
&.blur-text {
    filter: blur(5px);
}
`